function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgFlashFilled = function SvgFlashFilled(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Filled Flash' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M29.4594 0.000198364L27.1328 18.6126H40L18.5407 47.2251L20.8672 28.6126H8.00001L29.4594 0.000198364ZM23.1146 26.7579L23.1415 26.6045L21.4594 40.0002L21.8462 36.9055L23.1415 26.6045L26.5407 7.2251L23.1146 26.7579Z"
  }));
};

SvgFlashFilled = pure(SvgFlashFilled);
SvgFlashFilled.displayName = 'SvgFlashFilled';
export default SvgFlashFilled;